import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../axios';
import {
    Container,
    Form, FormBtn, FormCover,
    H1, H3,
    MediumSpacing
} from "../../styles";

const StudentEnrollmentUpdate = () => {
    const { id } = useParams(); // Enrollment ID
    const navigate = useNavigate();
    const [enrollment, setEnrollment] = useState(null);
    const [students, setStudents] = useState([]);
    const [classes, setClasses] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [grade, setGrade] = useState('');

    useEffect(() => {
        axios.get(`/student_enrollment/${id}/`)
            .then(response => {
                const enrollmentData = response.data;
                console.log("Enrollment data:", enrollmentData); // Log the response
                setEnrollment(enrollmentData);
                setSelectedStudent(enrollmentData.student);
                setSelectedClass(enrollmentData.class_enrolled);
                setGrade(enrollmentData.grade);
            })
            .catch(error => console.error("There was an error fetching the enrollment data!", error));

        axios.get('/students/')
            .then(response => {
                console.log("Students data:", response.data); // Log the response
                setStudents(response.data);
            })
            .catch(error => console.error("There was an error fetching the students!", error));

        axios.get('/classes/')
            .then(response => {
                console.log("Classes data:", response.data); // Log the response
                setClasses(response.data);
            })
            .catch(error => console.error("There was an error fetching the classes!", error));
    }, [id]);

    const handleSubmit = (event) => {
        event.preventDefault();
        axios.put(`/student_enrollment/${id}/`, {
            student: selectedStudent,
            class_enrolled: selectedClass,
            grade: grade
        })
            .then(response => {
                navigate(`/class/${selectedClass}`);
            })
            .catch(error => {
                console.error("There was an error updating the enrollment!", error);
                console.log("Error details:", error.response.data); // Log the detailed error response
            });
    };

    if (!enrollment) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <FormCover>
            <H3>Update Student Enrollment</H3>
            <MediumSpacing />
                <Form onSubmit={handleSubmit}>
                    <label>
                        Student:

                    </label>
                    <br/>
                    <select value={selectedStudent} onChange={(e) => setSelectedStudent(e.target.value)} required>
                        <option value="">Select a student</option>
                        {students.map(student => (
                            <option key={student.student_id} value={student.student_id}>
                                {student.first_name} {student.last_name}
                            </option>
                        ))}
                    </select>
                    <MediumSpacing/>
                    <label>
                        Class:
                    </label>
                    <br/>
                    <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)} required>
                        <option value="">Select a class</option>
                        {classes.map(classItem => (
                            <option key={classItem.id} value={classItem.id}>
                                {classItem.course_details.name} - {classItem.number}
                            </option>
                        ))}
                    </select>
                    <FormBtn type="submit">Update Enrollment</FormBtn>
                </Form>
            </FormCover>
        </Container>
    );
};

export default StudentEnrollmentUpdate;
